import { Component,Inject,OnDestroy,OnInit } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig,MatLegacyDialogRef as MatDialogRef,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BehaviorSubject } from 'rxjs';

import { PreviewComponent } from '../../../dave-dms-module/dave-dms/preview/preview.component';

export interface DaveFilePreviewComponentDialogData {
    fileId: number;
    emailEditorDialogData?:PreviewComponent['EmailEditorDialogData'];
    fileExplorerContext?: PreviewComponent['fileExplorerContext'];
    addBusinessVolumeDefaultValues?: PreviewComponent['addBusinessVolumeDefaultValues'];
}
@Component({
    selector: 'app-dave-file-preview',
    templateUrl: './dave-file-preview.component.html',
    styleUrls: ['./dave-file-preview.component.scss'],
})
export class DaveFilePreviewComponent implements OnInit, OnDestroy {
    public static DefaultConfig: MatDialogConfig = {
        maxWidth: '100vw',
        hasBackdrop: false,
        panelClass: 'custom-dialog-class-for-overlay-on-right-side',
    };
    public FileId$: BehaviorSubject<number>;

    constructor(private dialogRef: MatDialogRef<DaveFilePreviewComponent>, @Inject(MAT_DIALOG_DATA) public DialogData: DaveFilePreviewComponentDialogData) {}
    CloseDialog() {
        this.dialogRef.close();
    }

    ngOnInit(): void {
        this.FileId$ = new BehaviorSubject(this.DialogData.fileId);
    }

    ngOnDestroy(): void {
        this.FileId$.complete();
    }
}
